<template>
    <div>
      <div class="content">
        <div class="cont-list">
          <span class="list">{{
            this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
          <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
        </div>
        <div class="header">
          <div class="left">
            <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
              v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
            <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
              @reset="reset"></SelectFilter>
          </div>
        </div>
        <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
          style="width: 100%" @selection-change="handleSelectionChange" :summary-method="getSummaries" show-summary
          stripe :header-cell-style="{ background: '#DDEBFF',display: 'table-cell' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column align="center" type="selection"  width="55">
          </el-table-column>
          <el-table-column label="库房名称" min-width="150" align="center" prop="warehouseName" />
          <el-table-column label="不计费金额" align="center" min-width="200">
            <el-table-column width="120" prop="notBillingHighAmount" align="center" label="高值"></el-table-column>
            <el-table-column width="120" prop="notBillingNormalAmount" align="center" label="普通"></el-table-column>
          </el-table-column>
            <el-table-column label="不计费总金额" width="120" prop="notBillingTotalAmount" align="center" ></el-table-column>
          <el-table-column label="不计费同比" min-width="100" align="center" prop="notBillingAmountTongBi">
            <template slot-scope="scope">
              <p
                :style="{ color: scope.row.notBillingAmountTongBi > 0 ? 'orange' : scope.row.notBillingAmountTongBi == 0 ? '#606166' : '#286ab4' }">
                {{ scope.row.notBillingAmountTongBi==0?'-':scope.row.notBillingAmountTongBi + '%' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="不计费环比" min-width="100" align="center" prop="notBillingAmountHuanBi">
            <template slot-scope="scope">
              <p
                :style="{ color: scope.row.notBillingAmountHuanBi > 0 ? 'orange' : scope.row.notBillingAmountHuanBi == 0 ? '#606166' : '#286ab4' }">
                {{ scope.row.notBillingAmountHuanBi==0?'-':scope.row.notBillingAmountHuanBi + '%' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="计费金额" align="center"  >
            <el-table-column width="120" prop="billingHighAmount" align="center" label="高值"></el-table-column>
            <el-table-column width="120" prop="billingNormalAmount" align="center" label="普通"></el-table-column>
          </el-table-column>
          <el-table-column width="120" label="计费总金额" prop="billingTotalAmount" align="center"></el-table-column>
          <el-table-column label="计费同比" min-width="100" align="center" prop="billingAmountTongBi">
            <template slot-scope="scope">
              <p
                :style="{ color: scope.row.billingAmountTongBi > 0 ? 'orange' : scope.row.billingAmountTongBi == 0 ? '#606166' : '#286ab4' }">
                {{ scope.row.billingAmountTongBi==0?'-':scope.row.billingAmountTongBi + '%' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="计费环比" min-width="100" align="center" prop="billingAmountHuanBi">
            <template slot-scope="scope">
              <p
                :style="{ color: scope.row.billingAmountHuanBi > 0 ? 'orange' : scope.row.billingAmountHuanBi == 0 ? '#606166' : '#286ab4' }">
                {{ scope.row.billingAmountHuanBi==0?'-':scope.row.billingAmountHuanBi + '%' }}</p>
            </template>
          </el-table-column>
         
          <el-table-column label="消耗总金额" min-width="100" align="center" prop="amount" />
          <el-table-column label="消耗总金额同比" min-width="100" align="center" prop="amountTongBi">
            <template slot-scope="scope">
              <p
                :style="{ color: scope.row.amountTongBi > 0 ? 'orange' : scope.row.amountTongBi == 0 ? '#606166' : '#286ab4' }">
                {{ scope.row.amountTongBi==0?'-':scope.row.amountTongBi + '%' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="消耗总金额环比" min-width="100" align="center" prop="amountHuanBi">
            <template slot-scope="scope">
              <p
                :style="{ color: scope.row.amountHuanBi > 0 ? 'orange' : scope.row.amountHuanBi == 0 ? '#606166' : '#286ab4' }">
                {{ scope.row.amountHuanBi==0?'-':scope.row.amountHuanBi + '%' }}</p>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" min-width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="handleInfo(scope.row)" class="color-blue">查看图标</el-button>
            </template>
          </el-table-column> -->
        </el-table>
  
        <!-- <info :show="showInfo" :id="id" @handleClose="closeInfo"></info> -->
      </div>
  
      <Echarts v-if="show" :show="show" :title="title" :data="dataList" :time="time" @closeEvt="closeEvt"/>
      <div class="pagination">
        <el-pagination background layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
          :current-page="query.pageIndex" :total="total" @current-change="changePage">
        </el-pagination>
      </div>
    </div>
  </template>
  
  <script>
  import {
    GetWarehouseProductUseBillingReportViews,
    ExportWarehouseProductUseBillingReportViews,
  } from "@/api";
  import GetDataMixin from "@/mixin/getData-mixin.js";
  import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
  // import Info from './info';
  import SelectFilter from "@/components/table-select-filter";
  import Echarts from './echarts.vue'
  export default {
    mixins: [GetDataMixin, GetDataSpdMixin],
    components: {
      Echarts,
      SelectFilter,
    },
    data () {
      return {
        // 查询条件
        query: {
          keyWord: "",
          pageSize: 10,
          pageIndex: 1,
        },
        
        exportAction: ExportWarehouseProductUseBillingReportViews,
        // 列表数据
        tableData: [],
        // 列表总数
        total: 0,
        // 弹出框标题
        title: "",
        // 弹出编辑框
        open: false,
        // 打开详情
        showInfo: false,
        id: 0,
        // 多选框数据
        ids: [],
        multipleSelection: [],
        // 列表多选
        multiple: true,
        filterOptions: [
          {
            name: "库房",
            type: "select",
            code: "warehouseId",
            filterMethod: this.getWarehouses,
            data: [],
          },

          {
            name: "日期范围",
            type: "datetimerange",
            format:'yyyy-MM-dd HH:mm:ss',
            code: "date",
          },
        ],
        allTableDate: [],
        notBillingTotalAmount: 0,
        billingTotalAmount: 0,
        notBillingTotalAmount2: 0,
        billingTotalAmount2: 0,
        totalAmount: 0,
        show: false,
        dataList: [],
        time:'',
      };
    },
    methods: {
      handleSelectionChange (selection) {
        this.multipleSelection = selection;
        this.ids = selection.map((item) => item.id);
        this.multiple = !selection.length;
      },
      // 获取列表
      getData () {
        GetWarehouseProductUseBillingReportViews(this.query)
          .then((res) => {
            this.allTableData = res.returnData.filter(itme =>itme.amount!=0);
            this.total = this.allTableData ? this.allTableData.length : 0;

            this.tableData = this.getPaginationData(
              this.allTableData,
              this.query.pageIndex,
              this.query.pageSize
            );
  
            this.notBillingTotalAmount = 0;
            this.billingTotalAmount = 0;
            this.notBillingTotalAmount2 = 0;
            this.billingTotalAmount2 = 0;
            this.totalAmount = 0;
  
            if (this.allTableData) {
              this.allTableData.forEach((item) => {
                this.notBillingTotalAmount += item.notBillingAmount;
                this.billingTotalAmount += item.billingAmount;
                this.notBillingTotalAmount2 += item.notBillingAmount2;
                this.billingTotalAmount2 += item.billingAmount2;
                this.totalAmount += item.amount;
              });
              this.notBillingTotalAmount = this.notBillingTotalAmount.toFixed(3) * 1;
              this.billingTotalAmount = this.billingTotalAmount.toFixed(3) * 1;
              this.notBillingTotalAmount2 = this.notBillingTotalAmount2.toFixed(3) * 1;
              this.billingTotalAmount2 = this.billingTotalAmount2.toFixed(3) * 1;
              this.totalAmount = this.totalAmount.toFixed(3) * 1;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      getPaginationData (list, pageIndex, pageSize) {
        return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
      },
  
      // 改变当前页
      changePage (val) {
        this.$set(this.query, "pageIndex", val);
        this.tableData = this.getPaginationData(
          this.allTableData,
          this.query.pageIndex,
          this.query.pageSize
        );
      },
      handleSizeChange (val) {
        this.$set(this.query, "pageSize", val);
        this.tableData = this.getPaginationData(
          this.allTableData,
          this.query.pageIndex,
          this.query.pageSize
        );
      },
      // 重置
      reset () {
        this.query = {
          keyWord: "",
          pageSize: 10,
          pageIndex: 1,
          orgCode :sessionStorage.getItem('orgId')
        };
        if (this.$refs["selectFilter"]) {
          this.$refs["selectFilter"].resetQuery();
        }
        this.loading = true;
        this.getData();
      },
      queryChange () {
        this.$set(this.query, "pageIndex", 1);
        this.loading = true;
        this.getData();
      },
      filterChange (query) {
        this.query = Object.assign(this.query, query);
        this.loading = true;
        this.getData();
      },
  
      getSummaries (param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          } else if (column.property === "notBillingAmount") {
            sums[index] = this.notBillingTotalAmount + " 元";
          } else if (column.property === "billingAmount") {
            sums[index] = this.billingTotalAmount + " 元";
          } else if (column.property === "notBillingAmount2") {
            sums[index] = this.notBillingTotalAmount2 + " 元";
          } else if (column.property === "billingAmount2") {
            sums[index] = this.billingTotalAmount2 + " 元";
          } else if (column.property === "amount") {
            sums[index] = this.totalAmount + " 元";
          } else {
            sums[index] = "";
          }
        });
  
        return sums;
      },
      handleInfo (row) {
        this.title = row.deptName
        this.time = `${this.query.date[0]} 至 ${this.query.date[1]}`
        this.dataList = [
          {
            name: '医用耗材库-不计费',
            '同比期': row.notBillingAmountTongBi,
            '环比期': row.notBillingAmountHuanBi,
            '本期': row.notBillingAmount
          },
          {
            name: '医用耗材库-计费',
            '同比期': row.billingAmountTongBi,
            '环比期': row.billingAmountHuanBi,
            '本期': row.billingAmount
          },
          {
            name: '消毒供应库-不计费',
            '同比期': row.notBillingAmountTongBi2,
            '环比期': row.notBillingAmountHuanBi2,
            '本期': row.notBillingAmount2
          },
          {
            name: '消毒供应库-计费',
            '同比期': row.billingAmountTongBi2,
            '环比期': row.billingAmountHuanBi2,
            '本期': row.billingAmount2
          }
        ]
  
        console.log(this.dataList);
  
        this.show = true
      },
      getDate () {
        let today = new Date();
  
        // 获取年、月、日
        let year = today.getFullYear();
        let month = today.getMonth() + 1; // getMonth() 返回的是 0 到 11，所以需要加 1
        let day = today.getDate();
  
        // 格式化月份和日期，保证是两位数
        if (month < 10) {
          month = '0' + month;
        }
        if (day < 10) {
          day = '0' + day;
        }
  
        // 当前日期的字符串形式，格式为 YYYY-MM-DD
        let todayStr = `${year}-${month}-${day}`;
  
        // 计算30天前的日期
        let thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  
        // 获取年、月、日
        let agoYear = thirtyDaysAgo.getFullYear();
        let agoMonth = thirtyDaysAgo.getMonth() + 1; // getMonth() 返回的是 0 到 11，所以需要加 1
        let agoDay = thirtyDaysAgo.getDate();
  
        // 格式化月份和日期，保证是两位数
        if (agoMonth < 10) {
          agoMonth = '0' + agoMonth;
        }
        if (agoDay < 10) {
          agoDay = '0' + agoDay;
        }
  
        // 30天前的日期的字符串形式，格式为 YYYY-MM-DD
        let thirtyDaysAgoStr = `${agoYear}-${agoMonth}-${agoDay}`;
        return thirtyDaysAgoStr
      },
      closeEvt(boolean){
        this.show = boolean
      }
    },
    created () { },
    mounted () {
      this.query.date = [`${this.getDate()} 00:00:00`,`${this.parseTime(new Date(), "{y}-{m}-{d}")} 23:59:59`]
      this.query.endDate = `${this.parseTime(new Date(), "{y}-{m}-{d}")} 23:59:59`
      this.query.startDate = `${this.getDate()} 00:00:00`
      this.getData();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  /deep/ .el-table__header-wrapper {
  height: 100% !important;
}

// /deep/.el-table--border .el-table__cell {
//   border-right: 0px !important;
// }
/deep/.el-dialog__body  {
  overflow: auto !important;
}

</style>
  